import { type Html, $, html, on, rune, View } from 'rune-ts';
import klass from './CreatorCategory.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { MarkIcon } from '../../../../../shared/components/atoms/Icon';
import { SellerTypeFilters } from '../../../../../entities/pool/public/seller_type_filters';
import { filter, head, map, pipe, sortBy, toArray } from '@fxts/core';

interface CreatorCategorySelectProps {
  seller_types: SellerTypeFilters[];
  selected_category?: string;
}

export class CreatorCategorySelect extends View<CreatorCategorySelectProps> {
  override template({ seller_types }: CreatorCategorySelectProps): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    return html`
      <div class="${klass.form_item}">
        <label
          class="${klass.form_label} ${typoPcMo({
            is_mobile,
            pc: '16_bold',
            mo: '14_bold',
          })} required"
        >
          <div>${ET('mps2::ad_res::creator_cate')}</div>
          <div class="${klass.mark}">${MarkIcon}</div>
        </label>
        <div tabindex="0" class="${klass.cate_list} creator_category_list">
          ${this.makeCreatorCategoryListHtml(seller_types)}
        </div>
      </div>
    `;
  }

  private makeCreatorCategoryListHtml(seller_types: SellerTypeFilters[]) {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const name = ET.lang === 'kr' ? 'name' : (`name_${ET.lang}` as 'name' | 'name_en' | 'name_jp');
    const no = is_mobile ? 'mb_no' : 'no';

    return pipe(
      seller_types,
      filter((seller_type) => seller_type.is_hidden === false),
      sortBy((seller_type) => seller_type[no]),
      map(
        (seller_type) => html`
          <div
            class="${klass.cate} ${seller_type.name === this.data.selected_category ? klass.selected : ''}"
            data-id="${seller_type.id}"
          >
            ${seller_type[name]}
          </div>
        `,
      ),
      toArray,
    );
  }

  @on('click', `.${klass.cate_list}`)
  selectSellerType(e: Event) {
    if (e.target) {
      const el = $(`.${klass.selected}`);
      if (el) {
        el.removeClass(`${klass.selected}`);
      }
      const selected_el = e.target as HTMLElement;
      selected_el.classList.add(`${klass.selected}`);
    }
  }

  getSellerFilterTypeId() {
    const category_list = this.element().querySelectorAll<HTMLElement>(`.${klass.cate}`);
    return pipe(
      category_list,
      filter((category) => category.classList.contains(klass.selected)),
      map((category) => Number(category.getAttribute('data-id'))),
      head,
    );
  }

  isValidate() {
    return Boolean(this.getSellerFilterTypeId());
  }
}
